import { RawDraftContentState } from "draft-js";
import { Translations } from "shared/types/languages";

export type FaqGroup = {
  id: string;
  title: string;
  updatedAt: Date;
  createdAt: Date;
  order: number;
  status: FaqGroupStatus;
  questionsCount: number;
  translations?: Translations;
};

export type FaqGroupToUpdate = {
  title?: string;
  status?: FaqGroupStatus;
  order?: number;
  translations?: Translations;
};

export enum FaqGroupStatus {
  Active = "active",
  Draft = "draft",
}

export type UpdateStatusParams = {
  faqGroupId: string;
  status: FaqGroupStatus;
};

export type FaqGroupDataToCreate = Omit<
  FaqGroup,
  "id" | "updatedAt" | "createdAt"
>;

export type FaqGroupDataToUpdate = {
  id: string;
  order?: number;
};

export type FaqData = {
  id: string;
  updatedAt: Date;
  createdAt: Date;
  order: number;
  status: FaqGroupStatus;
  question: string;
  answer: {
    editorContent: RawDraftContentState | undefined;
  };
  translations?: Translations;
};

export type FaqDataToCreate = Omit<FaqData, "id" | "updatedAt" | "createdAt">;
export type FaqDataToUpdate = Partial<FaqDataToCreate>;

export type UpdateFaqStatusParams = {
  faqGroupId: string;
  faqId: string;
  status: FaqGroupStatus;
};

export enum VideoType {
  Youtube = "youtube",
  Vimeo = "vimeo",
  Loom = "loom",
}
